/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParamsSchema =
  z.object({
    reactivate: z.boolean().default(false),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse>;
